import { Autocomplete, Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import { selectActiveExpertUserOptions } from "../../user/expertUsersSlice";

const EezyContactPerson = () => {
  const { control } = useFormContext();

  const { t } = useTranslation();

  const expertUserOptions = useAppSelector((state) => selectActiveExpertUserOptions(state));

  const formattedExpertUsers = expertUserOptions.map((option) => ({
    salesPersonId: option.id,
    salesPersonName: option.name,
  }));

  return (
    <FormSection title={t("customers:companyInfo:eezyContactPerson")} margin>
      <Grid
        container
        item
        xs={2.8}
        justifyContent="flex-end"
        alignItems="center"
      >
        <Typography variant="secondary">
          {t("customers:companyInfo:contactPerson")}
        </Typography>
      </Grid>
      <Grid item xs={9.2}>
        <Controller
          name="eezyContactPerson"
          control={control}
          rules={{ required: true }}
          render={({ field, formState }) => (
            <Autocomplete
              sx={{ maxWidth: "372px" }}
              value={field.value}
              getOptionLabel={(option) => option.salesPersonName}
              isOptionEqualToValue={(option, selectedValue) =>
                option.salesPersonId === selectedValue.salesPersonId
              }
              onChange={(_, newValue) => field.onChange(newValue)}
              options={formattedExpertUsers}
              renderOption={(props, option) => (
                <li {...props} key={option.salesPersonId}>
                  {option.salesPersonName}
                </li>
              )}
              renderInput={(params) => (
                <CommonTextField
                  {...params}
                  error={!!formState.errors[field.name]}
                />
              )}
            />
          )}
        />
      </Grid>
    </FormSection>
  );
};

export default EezyContactPerson;
